
import { PaymentProcessEnum } from '../../enums';
import { GetPaymentsPayload } from '../../models/crm/types';

import { TransactionsState } from './types';

export const DEFAULT_TRANSACTIONS_PAGE_SIZE = 15;
export const DEFAULT_TRANSACTIONS_DATE_OFFSET = 365;
export const ALL_TRANSACTIONS_PAGE_SIZE = 1000;
export const ALL_TRANSACTIONS_DATE_OFFSET = 5 * DEFAULT_TRANSACTIONS_DATE_OFFSET;
export const FIRST_PAGE_NUMBER = 1;

export const INITIAL_TRANSACTIONS_STATE: TransactionsState = {
  data: [],
  filteredOut: [],
  ignored: [],
  pageSize: DEFAULT_TRANSACTIONS_PAGE_SIZE,
  orderColumn: 'payment_id', // orderColumn should be name of parameter from response model(see ../../models/crm/types/Payment)
  orderAscending: false,
  callsInQueue: [] as GetPaymentsPayload[],
};

export const TRANSACTIONS_FILTER = {
  paymentProcess: [
    PaymentProcessEnum.Deposit,
    PaymentProcessEnum.Withdrawal,
    PaymentProcessEnum.Adjustment,
  ],
  pageNumber: 1,
  defaultPageNumber: 1,
  pageSize: DEFAULT_TRANSACTIONS_PAGE_SIZE,
  dateOffset: DEFAULT_TRANSACTIONS_DATE_OFFSET,
};

export const ALL_TRANSACTIONS_FILTER = {
  paymentProcess: [
    PaymentProcessEnum.Deposit,
    PaymentProcessEnum.Withdrawal,
    PaymentProcessEnum.Adjustment,
  ],
  pageNumber: 1,
  defaultPageNumber: 1,
  pageSize: ALL_TRANSACTIONS_PAGE_SIZE,
  dateOffset: ALL_TRANSACTIONS_DATE_OFFSET,
  isAllTransactions: true,
};
